/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module ItemsModule
 */

import { AviPermissionResource } from 'generated-types';
import { Item } from 'ajs/modules/data-model/factories/item.factory';

/**
 * Interface for License Pool data structure from API.
 */
interface ILicensePool {
    _last_modified?: string;
    pool_id?: string;
    pool_name?: string;
}

interface ILicensePoolData {
    config: ILicensePool;
}

/**
 * Ajs dependency token for LicensePool.
 */
export const LICENSE_POOL_ITEM_TOKEN = 'LicensePool';

/**
 * @description License Pool item.
 * @author Deepak Chaudhary
 */
export class LicensePoolItem extends Item<ILicensePool> {
    public getConfig!: () => ILicensePool;
    public data!: ILicensePoolData;

    constructor(args = {}) {
        const extendedArgs = {
            objectName: 'albservices/pool',
            windowElement: 'lazy-load',
            permissionName: AviPermissionResource.PERMISSION_SYSTEMCONFIGURATION,
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    public getName(): string {
        return this.getConfig()?.pool_name ?? '';
    }

    /** @override */
    public getRef(): string {
        return this.getConfig()?.pool_id ?? '';
    }

    /** @override */
    // eslint-disable-next-line no-underscore-dangle
    protected getIdFromData_(data: ILicensePoolData): string {
        return data?.config?.pool_id ?? '';
    }
}
